<template>
	<div class="page-footer">
		<div class="header">
			<div class="item">
				<img src="images/gong-zhong-hao-qr-code.jpg" alt="">
				<div>关注"护工来啦"</div>
				<div>一键预约</div>
			</div>
		</div>
		<div class="section">
			<template v-for="(item,index) in headerLiftList">
				<div class="section-title" v-on:click="menuChangFun(index)">
					<div class="left-view">{{item[0].name}}</div>
					<div class="right-view">
						<div class="arrow-right"></div>
					</div>
				</div>
				<div class="section-list-item" v-on:click="navigatorToFun(cItem.path)" v-for="cItem,cIndex in item" v-if="cIndex!=0" v-show="showHeaderLiftListIndex == index">{{cItem.name}}</div>
			</template>
		</div>
		<div class="footer">
			<div class="company">护工来啦（上海）科技有限公司</div>
			<!-- <div class="mobile" v-on:click="callCompanyFun('400-600-5055')">400-600-5055</div> -->
		</div>
		<div class="aside">Copyright  2021-2022 护工来啦（上海）科技有限公司 版权所有 保留一切权利 |
			<a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022001431号-1</a>
		</div>
	</div>
</template>

<script>
	export default{
		name: "PageFooterMobile",
		data (){
			return {
				showHeaderLiftListIndex: -1,
				headerLiftList:[
					[{
						name: "关于我们",
						path: "/about"
					},{
						name: "公司简介",
						path: "/about"
					},{
						name: "核心优势",
						path: "/about"
					},{
						name: "用户价值",
						path: "/about"
					},{
						name: "智慧基因",
						path: "/about"
					},{
						name: "使命",
						path: "/about"
					}],
					[{
						name: "服务中心",
						path: "/productCenter"
					},{
						name: "医疗服务",
						path: "/productCenter"
					},{
						name: "护理服务",
						path: "/productCenter"
					},{
						name: "康复服务",
						path: "/productCenter"
					},{
						name: "养老服务",
						path: "/productCenter"
					},{
						name: "护理服务托管",
						path: "/productCenter"
					},{
						name: "职业技能培训",
						path: "/productCenter"
					}],
					[{
						name: "门店网点",
						path: "/storeOutlets"
					},{
						name: "护工来啦门店",
						path: "/storeOutlets"
					},{
						name: "服务内容",
						path: "/storeOutlets"
					},{
						name: "网点分布",
						path: "/storeOutlets"
					},{
						name: "合作加盟",
						path: "/storeOutlets"
					}]
				]
			}
		},methods:{
			menuChangFun (value){
				if(this.showHeaderLiftListIndex != value){
					this.showHeaderLiftListIndex = value;
				}else{
					this.showHeaderLiftListIndex = -1;
				}
			},navigatorToFun(path){
				if(this.$route.path == path){
					
				}else{
					this.$router.push(path);
				}
				util.scrollTo(0,0, false);
			},callCompanyFun (value){
				window.location.href = "tel:" + value;
			}
		}
	}
</script>

<style scoped="scoped">
	.page-footer{
		box-sizing: border-box;
		background: #FBFBFB;
		padding: 60px 16px 90px 16px;
	}
	.page-footer>.header{
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		padding-top: 32px;
		box-sizing: border-box;
	}
	.page-footer>.header>.item{
		flex-shrink: 0;
		margin-left: 28px;
	}
	.page-footer>.header>.item:nth-of-type(1){
		margin-left: 0;
	}
	.page-footer>.header>.item>img{
		width: 108px;
		display: block;
		border-radius: 2px;
		margin: 0 auto;
		border: 1px dashed #aaaaaa;
	}
	.page-footer>.header>.item>div{
		color: #4788F4;
		font-size: 14px;
		text-align: center;
	}
	.page-footer>.header>.item>div:nth-of-type(1){
		margin-top: 8px;
	}
	.page-footer>.section{
		padding-top: 21px;
		box-sizing: border-box;
	}
	.page-footer>.section>.section-title{
		padding: 8px 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
	}
	.page-footer>.section>.section-title>.left-view{
		font-size: 18px;
		line-height:1.6;
		color:#1B1F25;
		width: 1px;
		flex: 1 1 auto;
	}
	.page-footer>.section>.section-title>.right-view{
		margin-left: 12px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.page-footer>.section>.section-title>.right-view>.arrow-right{
		width: 12px;
		height: 12px;
		flex-shrink: 0;
		box-sizing: border-box;
		transform-origin: center center;
		border-left: 2px solid #707070;
		border-bottom: 2px solid #707070;
		transform: rotateZ(-45deg);
	}
	.page-footer>.section>.section-list-item{
		padding: 6px 18px;
		box-sizing: border-box;
		font-size: 12px;
		color: #1B1F25;
		line-height: 1.6;
	}
	.page-footer>.aside{
		margin-top: 36px;
		text-align: center;
		font-size: 6px;
		color: #999999;
		padding: 0 12px;
		box-sizing: border-box;
	}
	.page-footer>.footer{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding-top: 32px;
		box-sizing: border-box;
	}
	.page-footer>.footer>.company{
		font-size: 16px;
		color: #333333;
		font-weight: bold;
		line-height: 1.6;
	}
	.page-footer>.footer>.mobile{
		color: #007AFF;
		font-size: 14px;
		margin-top: 8px;
	}
</style>
